<template>
  <div class=" o_list">
    <van-nav-bar
      class="bar"
      title="返利详情"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
       @click-right="onClickRight"
      :fixed="true"
    >
     <template #right>
    <van-icon name="down" size="18" />
  </template>
    </van-nav-bar>
     <van-field @click="show" readonly v-model="value" label="开始时间" placeholder="请选择开始时间" />
     <van-field @click="show2" readonly v-model="value2" label="结束时间" placeholder="请选择结束时间" />
     <div class="but">
      <van-button @click="ca" style="width:100%"  size="large" type="primary">按时间查询</van-button>
      <!-- <van-button style="width:50%" type="danger"  size="large" >查询全部</van-button> -->
     </div>
  <van-tabs
      v-model="active"
      @change="change"
    >
      <van-tab
        class="tab"
        :title="v"
        v-for="v in nav"
        :key="v"
      >
     
        <div class="list">
          <van-list
            
            :finished="finished"
       
            offset="500"
            @load="onLoad"
          >
             <van-cell v-for="item in list" :key="item.id"  >
                <div class="fa">
                <div class="">{{item.create_time}} <span>{{item.remarks}} </span></div>
                <div class="din">订单号：{{item.order_sa_id}} <span></span></div>
                <div :class="item.flag==1?'money1':'money'">{{item.flag==1?'+':'-'}}￥{{item.fanli_money}}</div>
                </div>                
             </van-cell>  
          </van-list>

        </div>
      </van-tab>

    </van-tabs>
<van-popup
        v-model="showPicker2"
        position="bottom"
      >
       <van-picker
  show-toolbar
  title="选择年月"
  :columns="columns"
  @confirm="ok"
  @cancel="close"
/>
      </van-popup>
      <van-popup
        v-model="showPicker"
        position="bottom"
      >
       <van-picker
  show-toolbar
  title="选择年月"
  :columns="columns"
  @confirm="ok2"
  @cancel="close"
/>
      </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
// import List from './child/list'
import { NavBar, Tab, Tabs, List, Cell, Search, Dialog, Toast, CountDown,Picker,Popup,Field,Button } from 'vant'
// import Button from '../login/child/button.vue'

Vue.use(NavBar).use(Tabs).use(Tab).use(Cell).use(List).use(Search).use(Dialog).use(CountDown).use(Picker).use(Popup)
.use(Field).use(Button)
export default {
  created () {

  },
  mounted () {
    // this.deng()
    // window.addEventListener('scroll', this.windowScroll)
      const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://cdn.bootcdn.net/ajax/libs/xlsx/0.16.5/xlsx.mini.min.js';
    document.body.appendChild(s);
  },
  beforeDestroy () {
    // window.removeEventListener('scroll', this.windowScroll)
  },

  data () {
    return {
      value: '',
      value2:'',
      title: '订单列表',
      nav: ['全部','加计', '扣减'],
      active: 0,
      states: true,
      list: [],
      xlist: [],
      list1:[],
      list2:[],
      loading: false,
      finished: false,
      page: 1,
      columns: [
        // 第一列
        {
          values: [ '2024', '2025','2026','2027'],
          defaultIndex: 0,
        },
        // 第二列
        {
          values: ['1', '2', '3','4','5','6','7','8','9','10','11','12'],
          defaultIndex: 0,
        },
      ],
      showPicker2:false,
      showPicker:false,
    }
  },
  methods: {
  show(){
    this.showPicker2=true
  },
   show2(){
    this.showPicker=true
  },
  ok(v,i){
    console.log(v,i)
    this.value=v[0]+'-'+v[1]
    this.showPicker2=false
  },
   ok2(v,i){
    console.log(v,i)
    this.value2=v[0]+'-'+v[1]
    this.showPicker=false
  },
  close(){
    this.showPicker2=false
    this.showPicker=false
  },
  ca(){
    console.log()
    if( this.value){

    }else{
      Toast('请选择开始时间')
      return
    }
    if( this.value2){

    }else{
      Toast('请选择结束时间')
      return
    }
    this.active=0
    // console.log( this.value+'-1')s
    let ed1 = this.value+'-1'
    let st1 = this.value2+'-30'
    this.axios.post('getFanliList',{ start:(new Date(ed1.replace(/-/g,'/')).getTime())/1000  ,end:(new Date(st1.replace(/-/g,'/')).getTime())/1000, }).then(res => {       
          console.log(res)       
        this.list=res.data.data
        this.xlist=res.data.data
        res.data.data.forEach(v=>{
          if(v.flag==1){
            this.list1.push(v)
          }else{
            this.list2.push(v)
          }
        })
          this.finished=true
          // console.log(res)
      }).catch(ref => {
      })
  },
  
    onClickLeft () {
      this.$router.go(-1)
    },
   
    change (name) {
      // this.list = []
      // this.page = 1
      // this.onLoad(name)
      console.log(name)
      if(name==0){
        this.list=this.xlist
      }else if(name==1){
        console.log(1)
        this.list=this.list1
      }else{
        this.list=this.list2
      }
    },
    onLoad (v) {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      // this.deng(v)
    },
   
   
    go (v) {
     
    },
    godetails (v, i) {
      this.$router.push({ name: 'details', params: { id: v, i } })
    },
    ash (v,i) {
      
    },
   onClickRight(){
    if(this.list.length==0){
      Toast('暂无数据')
      return
    }
let ax=[]
      this.list.forEach(v=>{
        ax.push([v.create_time,v.order_sa_id,v.flag==1?'+'+v.fanli_money:'-'+v.fanli_money])
      })
      console.log(ax)
      // return false
       const sheetname = 'sheet1'
        let workbook = {
          SheetNames: [sheetname],
          Sheets: {}
        }
        let sheet = XLSX.utils.json_to_sheet(ax)
        sheet.A1.v = '时间'
        sheet.B1.v ='订单号'
        sheet.C1.v = '金额'
        workbook.Sheets[sheetname] = sheet
        // 生成excel的配置项
        const wopts = {
          bookType: 'xlsx', // 要生成的文件类型
          bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
          type: 'binary'
        };
        const wbout = XLSX.write(workbook, wopts);
        const blob = new Blob([this.s2ab(wbout)], {
          type: "application/octet-stream"
        });
        this.download(blob, '返利详情.xlsx')
   },
   download(blob, name) {
        // 用URL.createObjectURL下载
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url;
        a.download = name;
        let event;
        if (window.MouseEvent) {
          event = new MouseEvent('click');
        } else {
          event = document.createEvent('MouseEvents');
          event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        }
        a.dispatchEvent(event);
      },
      s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },
  },
  components: {
    // Button
    // List
  }
}
</script>
<style lang="less" scoped>
.fa{
    position: relative;
    // height: 10rem;
    .money{
        color: rgb(4, 162, 4);
    position: absolute;
    right: 0;
    top: 30%;}
    .money1{
        color: rgb(235, 61, 12);
    position: absolute;
    right: 0;
    top: 30%;}
    span{
      padding-left: 0.2rem;
    }
}

.sear {
  height: 1rem;
  .van-search {
    height: 1rem;
  }
}
.o_list {
  padding-top: 1.2rem;
  .bar {
    z-index: 99;
  }
}
.cs {
  text-align: center;
  color: red;
}
.tab {
  padding: 0.3rem 0;
  background-color: #f7f7f7;
}
.list {
  background-color: #f7f7f7;
}
.van-cell {
  // margin: 0.3rem 0;
}
.shop {
  background-color: #fff;
  // padding: 0 0.3rem;
  .head {
    display: flex;
    height: 1rem;
    line-height: 1rem;
    justify-content: space-between;
    .name {
      font-size: 0.4rem;
    }
    .time {
      padding-top: 0.15rem;
      color: #a22d2b;
    }
    .state {
      font-size: 0.4rem;
      color: #a22d2b;
    }
  }
  .body {
    background-color: #fff;
    border-top: 1px solid #efefef;
    .dianj {
      text-align: center;
    }
    li {
      border-bottom: 1px solid #efefef;
      padding: 0.3rem 0;
      position: relative;

      img {
        width: 2.4rem;
        height: 2.4rem;
        float: left;
      }
      .conten {
        padding-left: 2.8rem;
        // position: absolute;
        .title {
          width: 80%;
          color: #333;
          line-height: 0.36rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .type {
          width: 90%;
          color: #888;
          padding-top: 0.2rem;
        }
        .price {
          padding-top: 0.5rem;
          font-weight: 700;
          font-size: 0.45rem;
        }
        .num {
          position: absolute;
          right: 5%;
          color: #888;
          top: 2%;
        }
      }
    }
  }
  .foot {
    .bei {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    background-color: #fff;
    .statistics {
      padding: 0.2rem;
      padding-top: 0;
      .money {
        padding-left: 0.3rem;
        font-size: 0.4rem;
        color: #333;
        span {
          font-size: 0.453333rem;
        }
      }
      .number {
        font-size: 0.4rem;
        color: #333;
      }
    }
    .but {
      text-align: right;
      padding: 0.2rem 0 0.5rem 0;
      button {
        width: 2rem;
        height: 0.8rem;
        background: #fff;

        border-radius: 5px;
        outline: none;
        margin-left: 0.2rem;
      }
      .ash {
        border: 1px solid #b0b0b0;
        color: #b0b0b0;
      }
      .red {
        border: 1px solid #a22d2b;
        color: #a22d2b;
      }
      .orange {
        border: 1px solid #f97817;
        color: #f97817;
      }
    }
  }
}
</style>
